import { Stack, Typography } from '@mui/material';
import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      <Stack justifyContent="center" alignItems="center">
        <Typography>Rajaaat 🐍🐍🐍</Typography>
      </Stack>
    </footer>
  );
}
